<template>
<div>
  <el-dialog title="SSH Known Hosts" :visible.sync="visible" width="800px" :close-on-click-modal="false" @closed="focusCurTerm">
    <div style="text-align: left">
      <div v-show="!knownHosts || knownHosts.length < 1">当前没有已知主机</div>
      <div>
        <el-table 
        :data="knownHosts.filter(h => !search || h.toSearchString().toLowerCase().includes(search.toLowerCase()))" 
        height="550" 
        border 
        style="width: 100%"
        :header-row-style="{height: '3.5em'}"
        >
          <el-table-column type="index" width="50" label="序号" />
          <el-table-column v-if="!rawMode" label="主机列表">
            <template slot-scope="scope">
              <span v-for="host in scope.row.Hosts" :key="host"><el-tag class="host">{{host}}</el-tag></span>
            </template>
          </el-table-column>
          <el-table-column v-if="!rawMode" label="指纹(MD5)" class="fingerprint">
            <template slot-scope="scope">
              <span class="fingerprint">{{scope.row.FingerprintLegacyMD5}}</span>
            </template>
          </el-table-column>
          <el-table-column v-if="rawMode" label="主机记录" class="fingerprint">
            <template slot-scope="scope">
              <span class="fingerprint">{{scope.row.Raw}}</span>
            </template>
          </el-table-column>
          <el-table-column  width="200" align="right">
            <template slot="header" slot-scope="scope">
              <!-- 这里必须有 slot-scope, 否则输入框只能输入单个字符, 放到一个不可见的 span 中确保能编译 -->
              <span v-if="false">{{scope}}</span>
              <div class="hdr-tools">
                <el-input :id="focusID" v-model="search" size="mini" placeholder="搜索" />
                <el-tooltip content="以原始文本记录形式显示" placement="bottom-end">
                  <el-switch v-model="rawMode" class="hdr-btn" />
                </el-tooltip>
              </div>
            </template>
            <template slot-scope="scope">
  <!--            <el-button size="mini" @click="editHandler(scope.row.name, scope.row.raw)" class="el-icon-edit" />-->
              <el-button size="mini" @click="detailsHandler(scope.row)" class="el-icon-tickets" />
              <el-popconfirm title="确认删除该主机记录?" @confirm="delHandler(scope.row.SshAuthorizedKey)" >
                <el-button slot="reference" class="el-icon-delete row-tool-btn" size="mini" type="danger" />
              </el-popconfirm>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button size="mini" @click="loadData">刷新</el-button>
      <el-button size="mini" @click="importHandler">导入</el-button>
      <el-button class="footer-btn" size="mini" @click="exportHandler">导出</el-button>
      <el-popconfirm title="确认清空所有记录?" @confirm="clearHandler" >
        <el-button class="footer-btn" slot="reference" size="mini" type="danger">清空</el-button>
      </el-popconfirm>
      <el-button size="mini" @click="hide" type="primary">关闭</el-button>
    </span>
  </el-dialog>

<!--  details dialog-->
  <el-dialog title="SSH Known Host" :visible.sync="detailsVisible" width="600px" @closed="focus">
    <Details :sshKnownHost="detailsHost" />
    <span slot="footer" class="dialog-footer">
    <el-button size="mini" @click="detailsVisible = false;" type="primary">关闭</el-button>
  </span>
  </el-dialog>

  <import ref="importHosts" @closed="focus" @success="loadData" />

</div>
</template>

<script>
import Details from "./details";
import Import from "./import";
export default {
  name: "sshKnownHosts",
  components: {Import, Details},
  mounted() {
    let self = this
    this.env.ui.showSshKnownHostsAddCallback(() => {self.show()})
  },
  data() {
    return {
      visible: false,
      knownHosts: [],
      search: "",
      focusID: "ssh-known-hosts-search",
      rawMode: false,

      detailsVisible: false,
      detailsHost: undefined,

      importVisible: false,
    }
  },
  watch: {
    rawMode: function() {
      localStorage.setItem("ssh-known-hosts-raw-mode", JSON.stringify(this.rawMode))
    }
  },
  methods: {
    show: function() {
      this.visible = true
      this.focus()
      this.loadData()

      // set rawMode
      let rawMode = localStorage.getItem("ssh-known-hosts-raw-mode")
      if (rawMode !== null) {
        this.rawMode = JSON.parse(rawMode)
      }
    },
    hide: function() {this.visible = false},
    focus() {
      this.utils.domFocusById(this.focusID)
    },
    focusCurTerm() {
      this.env.term.focusCurrent()
    },
    loadData() {
      let self = this
      self.api.ssh.getSshKnownHosts((error, data, response) => {
        if (error) {
          self.api.errHandler(self, error, response)
          return
        }
        // console.log("getSshKnownHosts data:", data)
        self.knownHosts = []
        if (!data || data.length < 1) {
          return
        }
        for (let h of data) {
          let knownHost = self.model.SshKnownHost.NewFromApiData(h)
          self.knownHosts.push(knownHost)
        }

      })
    },
    detailsHandler(host) {
      this.detailsHost = host
      this.detailsVisible = true
    },
    delHandler(sshAuthorizedKey) {
      let self = this
      if (!sshAuthorizedKey) {
        self.$message.error("删除失败, 未指定 sshAuthorizedKey")
        return
      }
      self.api.ssh.deleteSshKnownHost(sshAuthorizedKey, (error, data, response) => {
        if (error) {
          self.api.errHandler(self, error, response)
          return
        }
        self.$message.success("删除成功")
        self.loadData()
      })
    },
    clearHandler() {
      let self = this
      self.api.ssh.deleteSshKnownHosts((error, data, response) => {
        if (error) {
          self.api.errHandler(self, error, response)
          return
        }
        self.$message.success("清空成功")
        self.loadData()
      })
    },
    importHandler() {
      this.$refs.importHosts.show()
    },
    exportHandler() {
      let text = ""
      if (!this.knownHosts || this.knownHosts.length < 1) {
        this.$message.warning("无法导出: 当前没有主机记录")
        return
      }
      for (let host of this.knownHosts) {
        if (text) text += "\n"
       text += host.Raw
      }
      this.utils.downloadText("known_hosts", text)
    },
  },
}
</script>

<style scoped>
.hdr-tools {
  display: flex;
  align-items: center;
}
.hdr-btn {
  margin-left: 8px;
}
.row-tool-btn {
  margin-left: 8px;
}
.footer-btn {
  margin-right: 8px;
}
.host {
  margin: 4px;
}
.fingerprint {
  font-size: 0.8em;
}
</style>
